module.exports = __webpack_public_path__ + "static/media/react.668601b7.png";